<template>
    <div class="main-layout">
        <NavBar />
        <SideBar @sidebar-toggle="handleSidebarToggle" />

        <main class="content" :class="{ 'content-expanded': sidebarCollapsed }">
            <router-view></router-view>

            <!-- Bouton de retour en haut de page -->
            <button v-show="showScrollTop" type="button" @click="scrollToTop" class="scroll-top-button"
                aria-label="Retour en haut de la page">
                <i class="fas fa-arrow-up text-sm"></i>
            </button>

            <!-- Bannière licence en phase de grâce (bas droite) -->
            <transition name="grace-banner">
                <div
                    v-if="gracePeriodBanner.show && gracePeriodBanner.graceEndDate"
                    class="grace-period-banner"
                >
                    <div class="grace-period-banner-content">
                        <i class="fas fa-exclamation-triangle text-danger flex-shrink-0"></i>
                        <div class="grace-period-banner-text">
                            <p>Votre licence est en phase de grâce.</p>
                            <p><strong>Fin de la période de grâce&nbsp;: {{ formatGraceEndDate(gracePeriodBanner.graceEndDate) }}</strong>. Passée cette date, l'application sera bloquée. Veuillez renouveler votre abonnement.</p>
                        </div>
                    </div>
                    <!-- <button
                        type="button"
                        class="grace-period-banner-close"
                        aria-label="Fermer"
                        @click="gracePeriodBanner.show = false"
                    >
                        <i class="fas fa-times text-xs"></i>
                    </button> -->
                </div>
            </transition>
        </main>

        <WhatsNewModal ref="whatsNewModal" />
    </div>
</template>

<script>
import NavBar from './NavBar.vue';
import SideBar from './SideBar.vue';
import WhatsNewModal from '@/components/ui/WhatsNewModal.vue';
import CashRegisterService from '@/services/cashRegisterService'
import physicalInventoryService from '@/services/physicalInventoryService'
import companySettingService from '@/services/companySettingService'
import companyService from '@/services/companyService'
import { registerFCMToken, onForegroundMessage } from '@/services/firebaseMessagingService'
import { useToastStore } from '@/store/modules/toastStore'

export default {
    name: 'MainLayout',
    components: {
        NavBar,
        SideBar,
        WhatsNewModal
    },
    data() {
        return {
            sidebarCollapsed: false,
            showScrollTop: false,
            company: null,
            unsubscribeFCM: null,
            gracePeriodBanner: { show: false, graceEndDate: null }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.$refs.whatsNewModal?.checkAndShow();
        this.getMyOpenedCashRegister();
        if (this.isMobileDevice()) {
            this.checkOngoingInventory().then(hasOngoingInventory => {
                console.log('hasOngoingInventory():', hasOngoingInventory)
                if (hasOngoingInventory) {
                    this.$router.push({ name: 'doing-inventory' })
                }
            })
        }

        this.getCompanySettings().then(settings => {
            console.log('settings():', settings)
        });

        this.getCurrentCompany().then(() => {
            if (!this.gracePeriodBanner.show) {
                try {
                    const stored = localStorage.getItem('company_active_licence')
                    const license = stored ? JSON.parse(stored) : null
                    if (license?.status === 'grace_period' && license?.grace_end_date) {
                        this.gracePeriodBanner = { show: true, graceEndDate: license.grace_end_date }
                    }
                } catch (_) { /* ignore parse error */ }
            }
        });

        this.registerFCMToken().then(err => {
            console.log('==============================================')
            console.log('registerFCMToken()', err)
            console.log('==============================================')
        });

        this.setupFCMListener();
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        if (this.unsubscribeFCM) {
            this.unsubscribeFCM();
        }
    },
    methods: {

        async getMyOpenedCashRegister() {
            CashRegisterService.pullAndSaveOpenedCashRegister();
        },
        handleSidebarToggle(collapsed) {
            this.sidebarCollapsed = collapsed;
        },
        handleScroll() {
            this.showScrollTop = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        formatGraceEndDate(dateStr) {
            if (!dateStr) return '—'
            const d = new Date(dateStr)
            return d.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        },

        isMobileDevice() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                window.innerWidth <= 768
        },

        async registerFCMToken() {
            return await registerFCMToken();
        },

        async setupFCMListener() {
            const toastStore = useToastStore();
            this.unsubscribeFCM = await onForegroundMessage((notification) => {
                this.playNotificationSound();
                toastStore.addToast({
                    type: 'info',
                    message: `${notification.title}: ${notification.body}`,
                    duration: 5000
                });
            });
        },

        playNotificationSound() {
            try {
                const audio = new Audio(require('@/assets/soungs/universfield-new-notification-017-352293.mp3'));
                audio.volume = 1;
                audio.play().catch(err => {
                    console.warn('Impossible de jouer le son de notification:', err);
                });
            } catch (error) {
                console.warn('Erreur lors du chargement du son:', error);
            }
        },

        async checkOngoingInventory() {
            try {
                const response = await physicalInventoryService.getInventories({
                    status: 'in_progress',
                    per_page: 1,
                    page: 1
                })

                return response.data && response.data.length > 0
            } catch (error) {
                console.error('Erreur lors de la verification de l\'inventaire:', error)
                return false
            }
        },
        async getCompanySettings() {
            try {
                const response = await companySettingService.getCompanySettings();
                localStorage.setItem('company_settings', JSON.stringify(response.data.data))
                console.log('company_settings():', localStorage.getItem('company_settings'))
            } catch (error) {
                console.error('Erreur lors de la recuperation des parametres de l\'entreprise:', error)
            }
        },
        async getCurrentCompany() {
            try {
                const response = await companyService.getCompanyCurrent();
                const companyData = response.data.data;
                console.clear();
                console.log('CURRENT COMPANY ===> :', companyData)
                localStorage.setItem('company', JSON.stringify(companyData))
                localStorage.setItem('company_active_licence', JSON.stringify(companyData?.active_license))

                const license = companyData?.active_license
                if (license?.status === 'grace_period' && license?.grace_end_date) {
                    this.gracePeriodBanner = { show: true, graceEndDate: license.grace_end_date }
                }
            } catch (error) {
                console.error('Erreur lors de la recuperation de l\'entreprise:', error)
            }
        }
    }
}
</script>
<style scoped>
.main-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #F8FAFC;
}

.content {
    margin-left: 256px;
    margin-top: 56px;
    padding: 24px;
    transition: margin-left 0.2s ease;
    min-height: calc(100vh - 56px);
    position: relative;
}

.content-expanded {
    margin-left: 72px;
}

.scroll-top-button {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background-color: #0D9488;
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 100;
}

.scroll-top-button:hover {
    background-color: #0F766E;
    transform: translateY(-2px);
}

/* Bannière phase de grâce - bas droite */
.grace-period-banner {
    position: fixed;
    bottom: 24px;
    right: 24px;
    max-width: 380px;
    padding: 14px 16px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    border-left: 4px solid red;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    z-index: 100;
}
.grace-period-banner-content {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex: 1;
    min-width: 0;
}
.grace-period-banner-text {
    margin: 0;
    font-size: 13px;
    line-height: 1.45;
    color: #374151;
}
.grace-period-banner-text p {
    margin: 0 0 6px 0;
}
.grace-period-banner-text p:last-child {
    margin-bottom: 0;
}
.grace-period-banner-close {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: #f3f4f6;
    color: #6b7280;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
}
.grace-period-banner-close:hover {
    background: #e5e7eb;
    color: #374151;
}
.grace-banner-enter-active,
.grace-banner-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}
.grace-banner-enter-from,
.grace-banner-leave-to {
    opacity: 0;
    transform: translateX(20px);
}

@media (max-width: 768px) {
    .content {
        margin-left: 0;
        padding: 16px;
    }

    .content-expanded {
        margin-left: 0;
    }
}
</style>
